import { marker } from '@colsen1991/ngx-translate-extract-marker';
import { MessageBase } from '../providers/message-base/message-base';

export class BaseError {
  public readonly description: string = marker('general.text.error');
  protected errorCode = 'base-error';

  public constructor(
    private messageService: MessageBase,
    message?: string,
  ) {
    this.description = message ?? this.description;
  }

  public async handle(): Promise<this> {
    // eslint-disable-next-line no-console
    console.error(`Error: ${this.errorCode} - ${this.description}`);
    await this.messageService.showError(this.description);

    return this;
  }
}
